import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Select } from '@matyas/matyaskar-forked-react-ui/'


const mapper = (item) => ({
  value: item.uuid,
  label: item.name,
})

const banner_image = document.querySelector('[data-name="banner_image"] div')
if (banner_image) {
  var banner_image_url = banner_image.style.backgroundImage
}


export default class TabbedSearch extends Component {
  static propTypes = {
    accommodationOptions: PropTypes.arrayOf(PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })).isRequired,
    venuesOptions: PropTypes.arrayOf(PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })).isRequired,
  }

  state = {
    tab: 'venues',
    accommodation: '',
    venue: '',
    inputValue :''
  }

  switchToTab = (tab) => (e) => {
    e.preventDefault()
    this.setState({ tab })
    if (tab !== 'venues') {
      banner_image.style.backgroundImage = 'url("/static/img/home_banner.jpg")'
    } else {
      banner_image.style.backgroundImage = banner_image_url
    }
  }

  handleSearch = ({ value }) => {
    var typedInSearchText = null;
    if (this.state.tab === 'accommodation'){
      typedInSearchText = this.refs.accommodationInput.state.inputValue
    }
    else{
      typedInSearchText = this.refs.venueInput.state.inputValue
    }
    let result = this.props.accommodationOptions.find((item) => item.uuid === value)

    if (! result) {
      result = this.props.venuesOptions.find((item) => item.uuid === value)
    }
    // now we handle the edge case that somebody typed in a result and hit the enter button.
    // when somebody hits the enter button the first selection of the selector gets selected (not necessarily the one
    // that matches the search text in the input field. So when the result label does not contain the characters of
    // the select input text we return the first result that matches input text. If no result matches the input text we
    // do nothing
      console.log('starting');
      if (result) {
          let fallBackOptionMatch = false;
          if (!typedInSearchText) {
              // no search text available probably it was a direct mouse click
              location.href = result.url
          }
          else {
              //  some sort of search text is available
              //the search text may also match a fallback option we check for that case as well here
              this.props.fallbackAccommodationOptions.map((eventOption) =>{
                  if(eventOption.name.toLowerCase().indexOf(typedInSearchText.toLowerCase()) > -1){
                      if(eventOption.uuid === result.uuid){
                          fallBackOptionMatch = true;
                     }
                  }
              } );
              if (result.name.toLowerCase().indexOf(typedInSearchText.toLowerCase()) > -1 || fallBackOptionMatch) {
                  // the result contains the characters of the typed in search text everything seems to be okay
                  console.log('found match in result:', result.name, result.url);
                  location.href = result.url
              }
              else {
                  // the result name does not contain the typed in search text. We return the first result that we find that
                  // contains the typed in search text in its name
                  if (this.state.tab === 'accommodation') {
                      // edge case when pressing enter the first drop down option gets selected in any case
                  // we try to find out the best redirect url based on the official name or the fallback nam
                  console.log('dealing with pressing enter edge case now!');
                      let firstMatchForSearchText = this.props.accommodationOptions.find(function (element) {
                        return element.name.toLowerCase().indexOf(typedInSearchText.toLowerCase()) > -1;
                      });
                      if(firstMatchForSearchText){
                        location.href = firstMatchForSearchText.url
                      }
                      else{
                          // the direct name search did not work let's go through the fallback options:
                          let fallbackMatchForSearchText = this.props.fallbackAccommodationOptions.find(function (element) {
                                return element.name.toLowerCase().indexOf(typedInSearchText.toLowerCase()) > -1;
                          });
                          if(fallbackMatchForSearchText){
                              location.href = fallbackMatchForSearchText.url;
                          }
                      }


                  }
                  else {
                      let firstMatchForSearchText = this.props.venuesOptions.find(function (element) {
                          return element.name.toLowerCase().indexOf(typedInSearchText.toLocaleLowerCase()) > -1;
                      });
                      if(firstMatchForSearchText){
                        //location.href = firstMatchForSearchText.url
                      }
                  }
              }

          }
    }
  }



  render () {
    const { accommodationOptions, fallbackAccommodationOptions, venuesOptions } = this.props
    const { tab } = this.state

    return (
      <div className='tabbed-search'>
        <ul className='tabbed-search__tabs'>
          <li className={tab === 'venues' ? 'active' : null}><button onClick={this.switchToTab('venues')}><span className='hidden-mobile'>Event</span> Venues</button></li>
          <li className={tab === 'accommodation' ? 'active' : null}><button onClick={this.switchToTab('accommodation')}><span className='hidden-mobile'>Event</span> Accommmodation</button></li>
        </ul>

        {tab === 'accommodation' && (
          <div className='tabbed-search__body'>
            <form className='form form--search'>
              <div className='form__row'>
                <Select
                  name='value'
                  updateValue={this.handleSearch}
                  options={accommodationOptions.map(mapper)}
                  fallbackOptions={fallbackAccommodationOptions.map(mapper)}
                  placeholder="I'm attending"
                  noOptionPlaceholder="Don't see your event? Contact us directly"
                  ref='accommodationInput'
                  value={this.state.inputValue}
                />
              </div>
            </form>
          </div>
        )}
        {tab === 'venues' && (
          <div className='tabbed-search__body'>
            <form className='form form--search'>
              <div className='form__row'>
                <Select
                  name='value'
                  updateValue={this.handleSearch}
                  options={venuesOptions.map(mapper)}
                  placeholder="I need a venue"
                  noOptionPlaceholder="Don't see your venue? Contact us directly"
                  ref='venueInput'
                  value={this.state.inputValue}
                />
              </div>
            </form>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/TabbedSearch.js